angular.module('leanlaw').filter("trim", ['$filter', function ($filter) {
  return function (text, limit) {
    return (text || "").trim();
  };
}]);